import { useEffect, useState, useRef } from "react";
import { getData } from "../script/api";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Products(){
  const [prodData, setProdData] = useState([[],[],[]]);

  const elementsRef = useRef([]);

  async function getDataList(){
    const response = await getData(`/api/product/list`);

    const responseObj = [[],[],[]];
    if (response?.data) {
      response.data.forEach((item) => {
        if(item.id >264){
          if (item.type === "subscribe") {
            responseObj[0].push(item);
          } else if (item.type === "joinFee") {
            if (! item.name.includes("얼리버드")) {
              responseObj[1].push(item);
            } else {
              responseObj[2].push(item);
            }
          }
        }
        
      });
    }
    setProdData(responseObj);
  }

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    if (prodData.flat().length > 0) {
      elementsRef.current.forEach((element) => {
        if (element) {
          gsap.fromTo(
            element,
            { opacity: 0, y: 100 },
            {
              opacity: 1,
              y: 0,
              duration: 1.5,
              ease: "power4.out",
              scrollTrigger: {
                trigger: element,
                start: "top 90%",
                toggleActions: "play none none none",
              },
            }
          );
        }
      });
      ScrollTrigger.refresh();
    }
  }, [prodData]);
  return(
    <>
        <div className="product_desc p-5 mt40">
            <div className="card">
               <p className="tac fz30 c3 pt60" ref={(el) => (elementsRef.current[0] = el)}>우연은 <span className="ffsd6 c1">기간제 서비스</span>와 <span className="ffsd6 c1">횟수제 서비스</span> 모두 운영하고 있으며</p>
               <p className="tac fz30 c3" ref={(el) => (elementsRef.current[1] = el)}>전문 매니저와의 1:1 상담을 통해 회원님께</p>
               <p className="tac fz30 c3 pb35" ref={(el) => (elementsRef.current[2] = el)}>꼭 맞는 <span className="ffsd6">합리적인 프로그램</span>을 추천해드립니다.</p>
        
            </div>

        </div>
      <div className="inday_container pb120">
        <h2 className="main_tit fz50 ffsd6 pb40 pt60 tac" ref={(el) => (elementsRef.current[3] = el)}><span className="fz60">1. </span><span className="mark_bg">우연 기간제 서비스</span></h2>
        <p className="tac fz22 c3 pb80" ref={(el) => (elementsRef.current[4] = el)}>기간제 서비스는 <span className="c1 ffsd6">기간 내 횟수 제한 없이 만남이 가능</span>한서비스 입니다.<br/>계약 기간 동안 매니저님과 원활히 소통하여 평생 인연 찾으시기 바랍니다.</p>
        <div className="product_lst subscribe2">
          {[...prodData[0]].reverse().map((item, i) => {
            const match = item.desc.match(/\[(.*?)\]/);
            const bracketContent = match ? match[0].replace("[", "").replace("]", "") : "";
            const translationMap = {BASIC: "베이직", PREMIUM: "프리미엄", DIAMOND: "다이아몬드",};
            const translatedContent = translationMap[bracketContent] || bracketContent;

            let otherContent = item.desc
              .replace(bracketContent, "")
              .trim()
              .replace("<br>", "\n")
              .replace("[", "")
              .replace("]", "");
              if(otherContent === "-"){
                otherContent = "\n\n";
              }
            return(
              <div className="item" key={i} ref={(el) => (elementsRef.current[i + 5] = el)}>
                <p className="t1 fz30 ffsd6">{translatedContent}</p>
                <div className="bottom_cont">
                  <p className="t2 tac fz50 ffsd6">{item.name}</p>
                  <hr style={{
                    width: '50%',
                    height: '2px',
                    backgroundColor: '#e5e5e5',
                    border: 'none',
                    margin: '20px auto'
                  }} />
                  <div className="bottom_txt_box tac">
                    <p className="p1 fz18">당일 결제 혜택</p>
                    <p className="p2 fz24 ffsd6"><span className="sameday_per">{item.samedayPer}%</span> 추가 할인</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        {/* <p className="pt30 tac fz22 c3" ref={(el) => (elementsRef.current[13] = el)}>우연은 정찰제로 운영되며 타사와 다르게 상담 후 가격이 변동되지 않습니다.</p> */}
      </div>
      <div className="membership_lst2" >
        <div className="inday_container">
          <h2 className="main_tit fz50 ffsd6 pb40 tac" ref={(el) => (elementsRef.current[13] = el)}><span className="fz60">2. </span><span className="mark_bg">우연 횟수제 서비스</span></h2>
          <p className="tac fz22 c3" ref={(el) => (elementsRef.current[14] = el)}>횟수제는 1년간 사용 가능하며 </p>
          <p className="tac fz22 c3 pb10" ref={(el) => (elementsRef.current[15] = el)}><span className="ffsd6 c1">1회 만남 시 매칭권 1회권이 소모</span>되는 서비스 입니다.</p>
          <p className=" fz16 c3 tac pb80" ref={(el) => (elementsRef.current[16] = el)}>*지방회원의 경우 보다 합리적인 가격으로 상담 시 자세하게 안내 드릴 예정입니다.</p>
          <div className="product_lst joinFee2">

          {prodData[1].map((item, i) => {
            const match = item.desc.match(/\[(.*?)\]/);
            const bracketContent = match ? match[0].replace("[", "").replace("]", "") : "";
            const translationMap = {BASIC: "베이직", PREMIUM: "횟수제", DIAMOND: "다이아몬드",};
            const translatedContent = translationMap[bracketContent] || bracketContent;

            let otherContent = item.desc
              .replace(bracketContent, "")
              .trim()
              .replace("<br>", "\n")
              .replace("[", "")
              .replace("]", "");
              if(otherContent === "-"){
                otherContent = "\n\n";
              }
            return(
              // <div className="item" key={i} ref={(el) => (elementsRef.current[i + 20] = el)}>
              //   <p className="t1 fz30 pb25 ffsd6">{translatedContent}</p>
              //   <div className="bottom_cont">
              //     <p className="t2 tac fz50">{item.name}</p>
              //   </div>
              // </div>
              <div className="item" key={i} ref={(el) => (elementsRef.current[i + 30] = el)}>
              <p className="t1 fz30 ffsd6">{translatedContent}</p>
              <div className="bottom_cont">
                <p className="t2 tac fz50 ffsd4">{item.name}</p>
              </div>
              </div>
            )
          })}
          </div>

        </div>

      </div>
      <p className="pt30 fz22 c3 tac" ref={(el) => (elementsRef.current[50] = el)}>*이벤트 내용에 따라 서비스 금액은 변동 될 수 있습니다.</p>
      <p className="fz22 c3 tac pb40" ref={(el) => (elementsRef.current[52] = el)}>*우연은 타사와 다르게 상담 후에는 가격이 변동되지 않습니다.</p>
    </>
  )
}
